module.exports = __webpack_public_path__ + "img/snow.9dc397b3.jpg";